import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import React from 'react';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

const list = Object.freeze([
  {
    id: 'libero di stato',
    value: 'libero di stato',
  },
  {
    id: 'libera di stato',
    value: 'libera di stato',
  },
  {
    id: 'celibe',
    value: 'celibe',
  },
  {
    id: 'nubile',
    value: 'nubile',
  },
  {
    id: 'coniugato',
    value: 'coniugato',
  },
  {
    id: 'coniugata',
    value: 'coniugata',
  },
  {
    id: 'divorziato',
    value: 'divorziato',
  },
  {
    id: 'divorziata',
    value: 'divorziata',
  },
  {
    id: 'unito civilmente',
    value: 'unito civilmente',
  },
  {
    id: 'unita civilmente',
    value: 'unita civilmente',
  },
  {
    id: 'libero da unione civile',
    value: 'libero da unione civile',
  },
  {
    id: 'libera da unione civile',
    value: 'libera da unione civile',
  },
  {
    id: 'vedovo',
    value: 'vedovo',
  },
  {
    id: 'vedova',
    value: 'vedova',
  },
  {
    id: 'vedovo da unione civile',
    value: 'vedovo da unione civile',
  },
  {
    id: 'vedova da unione civile',
    value: 'vedova da unione civile',
  },
  {
    id: 'presunto vedovo',
    value: 'presunto vedovo',
  },
  {
    id: 'presunta vedova',
    value: 'presunta vedova',
  },
  {
    id: 'non conosciuto',
    value: 'non conosciuto',
  },
]);

interface ListCivilStatusProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  size?: 'small' | 'medium';
  id?: string;
}

const ListCivilStatusComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  size,
  id,
}: ListCivilStatusProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} id={`${id}-label`}>
        {required ? 'Stato Civile *' : 'Stato Civile'}
      </InputLabel>
      <PmiSelect
        size={size}
        labelId={`${id}-label`}
        id={id}
        name={id}
        value={value}
        label={required ? 'Stato Civile *' : 'Stato Civile'}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {(list as Array<ItemVM>)?.map((category: ItemVM) => (
          <MenuItem key={category.id} value={category.id}>
            {category.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListCivilStatusComponent.displayName = 'List civil status component';

const ListCivilStatus = memo(ListCivilStatusComponent);

export default ListCivilStatus as typeof ListCivilStatusComponent;
